import { Injectable } from "@angular/core";
import { UtilityClient } from "src/app/models";
import { AppWebError } from "src/app/models";
import { SessionDataService } from "./session-data.service";

@Injectable({
    providedIn: "root",
})
export class ErrorLoggingService
{
    constructor(private utilityClient: UtilityClient,
        private sessionDataService: SessionDataService)
    {
    }

    /**
     * Logs the error to the updates01 database
     * @param error Error stacktrace
     */
    public logError(error: any): void
    {
        let appWebError: AppWebError = {
            DataLogical: this.sessionDataService.DataLogical,
            CustomerId: this.sessionDataService.CustId,
            IsWeb: true,
            ClientVersion: this.sessionDataService.ClientVersion,
            Unhandled: false
        };

        if (appWebError.DataLogical != null)
        {
            const errorMessage = JSON.stringify(error).toLowerCase();
            appWebError.ErrorMessage = errorMessage;

            const excludedPhrases = [
                "invalid login",
                "the customer, account",
                "an invalid request uri was provided",
                "undefined\nurl:",
                "too many failed login"
            ];

            const shouldLog = !excludedPhrases.some(phrase => errorMessage.includes(phrase));

            if (shouldLog)
            {
                this.utilityClient.logErrorWebV2(appWebError).subscribe();
            }
        }
    }

}
